import {
  GET_ANIMATIONS_LIST,
  ERROR_ANIMATIONS,
  SCROLL_ON_ANIMATIONS,
  GET_ANIMATION,
  MESSAGE_ANIMATIONS,
  REMOVE_FILE,
  SET_ANIMATIONS_FILTERS,

} from "../actions/types"

const initialState = {
  animationsList: [],
  error: {},
  scrollAnimations: 0,
  message: {},
  animation: {},
  filters: {
    search: "",
  },
};

export default function animationsReducer(state = initialState, action) {
  switch (action.type) {
    case REMOVE_FILE: 
      return { 
        ...state,
        message: action.payload.message,
        animation: {
          ...state.animation,
          files: state.animation.files.filter(item => item !== action.payload.fileName)
        }
      }
    case SET_ANIMATIONS_FILTERS:
      return {...state, filters : {...state.filters, ...action.payload }}
    case MESSAGE_ANIMATIONS:
      return {...state, message: action.payload}
    case GET_ANIMATION:
      return {...state, animation : action.payload}
    case GET_ANIMATIONS_LIST:
      return {...state, animationsList : action.payload}
    case ERROR_ANIMATIONS:
        return {...state, error: action.payload}
    case SCROLL_ON_ANIMATIONS:
      return {...state, scrollAnimations: action.payload}
    default:
      return {...state};
  }
}
